'use strict';

export default class ImportController {

  /*@ngInject*/
  constructor($http, $state, Upload, toaster) {
    this.$http = $http;
    this.$state = $state;
    this.Upload = Upload;
    this.toaster = toaster;
    
    this.newConf = {
      groups: []
    };
  }

  $onInit() {
    this.getList();
  }

  upload(file) {
    if (!file) {
      return;
    }
    this.toaster.pop({
      type: 'wait',
      title: '正在上传，请稍等...',
      body: file.name,
      timeout: 3000 * 1000
    });

    file.upload = this.Upload.upload({
      url: '/api/AppConfs/import',
      file: file,
      data: this.newConf,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.$state.go('appconfs.list');
      this.toaster.clear();
      this.toaster.pop('success', '上传成功', file.name);
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

  getList() {
    this.$http.get('/api/AppConfGroups').then(res => {
      this.groups = res.data;
    });
  }

  toggleSelection(id) {
    let idx = this.newConf.groups.indexOf(id);
    if(idx > -1) {
      this.newConf.groups.splice(idx, 1);
    } else {
      this.newConf.groups.push(id);
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/appconfs/import/import.controller.js